// TODO: Finish me. This view shows when the user hasn't selected any location and opens the audience picker.
export const EmptyView = () => {
  return <div>No location selected.</div>;
};
